import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { IUserState, UserStoreModule } from "@/store/users/user.store";
import { getModule } from "vuex-module-decorators";
import { RoleStoreModule, IRoleState } from "@/store/users/role.store";
import {
  IRiskProfileState,
  RiskProfileStoreModule
} from "@/store/risk_profile/riskprofile.store";
import {
  ILoadingSpinnerState,
  LoadingSpinnerStoreModule
} from "@/store/services/loadingspinner.store";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<IRootState>({
  storage: window.localStorage
});

export interface IRootState {
  user: IUserState;
  role: IRoleState;
  riskProfile: IRiskProfileState;
  loadingSpinner: ILoadingSpinnerState;
}

const store = new Vuex.Store<IRootState>({
  modules: {
    userStore: UserStoreModule,
    roleStore: RoleStoreModule,
    riskProfileStore: RiskProfileStoreModule,
    loadingSpinnerStore: LoadingSpinnerStoreModule
  },
  plugins: [vuexLocal.plugin]
});

export default store;
export const UserStore = getModule(UserStoreModule, store);
export const RoleStore = getModule(RoleStoreModule, store);
export const RiskProfileStore = getModule(RiskProfileStoreModule, store);
export const LoadingSpinnerService = getModule(
  LoadingSpinnerStoreModule,
  store
);
